/**
 * AI 去水印独立模块：优先走自有 AI 接口，失败时 fallback 到 TextIn（URL 入参，base64 出参）
 */
import { submitFullWatermarkRemover, pollOldPhotoRepairResult } from './oldPhotoRepair'
import { removeWatermark } from './textin'
import { uploadFile } from './upload'

function b64ToPngFile(b64Str, index) {
  var raw = String(b64Str || '').replace(/\s/g, '')
  var pad = raw.length % 4
  if (pad) raw += '===='.slice(0, 4 - pad)
  var binStr = atob(raw)
  var len = binStr.length
  var bytes = new Uint8Array(len)
  for (var i = 0; i < len; i++) bytes[i] = binStr.charCodeAt(i)
  var name = 'watermark-removed-' + Date.now() + '-' + index + '.png'
  return new File([bytes], name, { type: 'image/png' })
}

function parseTextinBase64(res) {
  var data = res && res.data
  if (data && data.code === 200 && data.result && data.result.image) {
    return String(data.result.image)
  }
  return ''
}

function pollAiWatermarkResult(promptId) {
  return new Promise(function(resolve, reject) {
    var poller = null
    poller = pollOldPhotoRepairResult(promptId, function(err, result) {
      if (result && result.status === 'processing') return
      if (poller && typeof poller.stop === 'function') poller.stop()
      if (err) {
        reject(err)
        return
      }
      var url = result && result.url ? String(result.url) : ''
      if (!url) {
        reject(new Error('No result image was returned'))
        return
      }
      resolve({ url: url, source: 'ai' })
    })
  })
}

function processTextinWatermark(imageUrl) {
  var url = String(imageUrl || '').trim()
  if (!url) return Promise.reject(new Error('imageUrl is required'))
  return removeWatermark(url).then(function(res) {
    var b64 = parseTextinBase64(res)
    if (!b64) return Promise.reject(new Error('TextIn watermark remove failed'))
    var file = b64ToPngFile(b64, 0)
    return uploadFile(file).then(function(serverUrl) {
      var resultUrl = typeof serverUrl === 'string' ? serverUrl : ''
      if (!resultUrl && serverUrl && serverUrl.url) resultUrl = serverUrl.url
      if (!resultUrl) return Promise.reject(new Error('TextIn result upload failed'))
      return { url: resultUrl, source: 'textin' }
    })
  })
}

function tryAiWatermark(imageUrl) {
  return submitFullWatermarkRemover(imageUrl).then(function(submitRes) {
    var promptId = submitRes && submitRes.promptId ? String(submitRes.promptId) : ''
    if (!promptId) return Promise.reject(new Error('removeImageWatermark did not return prompt_id'))
    return pollAiWatermarkResult(promptId)
  })
}

/**
 * @param {string} imageUrl 已上传的原图 HTTPS URL
 * @returns {Promise<{ url: string, source: 'ai'|'textin' }>}
 */
export function processWatermarkWithFallback(imageUrl) {
  var url = String(imageUrl || '').trim()
  if (!url) return Promise.reject(new Error('imageUrl is required'))
  return tryAiWatermark(url).catch(function() {
    return processTextinWatermark(url)
  })
}

export default {
  processWatermarkWithFallback: processWatermarkWithFallback
}
